import React from "react";
import { Filter, X } from "lucide-react";

const dayKey = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const EMPTY_FILTERS = { from: "", to: "", vendor: "" };

export function applyAdminFilters(rows, filters, dateKey) {
  return rows.filter((r) => {
    const k = dayKey(r[dateKey]);
    if (filters.from && k < filters.from) return false;
    if (filters.to && k > filters.to) return false;
    if (filters.vendor && (r.vendor_id || r.vendor_name) !== filters.vendor) return false;
    return true;
  });
}

export function AdminListFilters({ rows, filters, setFilters, shown, total, testPrefix = "filter" }) {
  const vendors = Array.from(new Map(rows.map((r) => [r.vendor_id || r.vendor_name, r.vendor_name || "—"])).entries())
    .sort((a, b) => (a[1] || "").localeCompare(b[1] || ""));
  const active = filters.from || filters.to || filters.vendor;
  const upd = (k) => (e) => setFilters((f) => ({ ...f, [k]: e.target.value }));
  const inp = "bg-ink border border-zinc-700 text-white text-sm px-3 py-2 focus:outline-none focus:border-neon-green min-h-[40px]";
  return (
    <div data-testid={`${testPrefix}-bar`} className="flex flex-wrap items-end gap-3 border border-zinc-800 bg-ink-surface p-3 mb-4">
      <span className="inline-flex items-center gap-1 text-zinc-400 text-xs uppercase font-bold pb-2"><Filter className="h-4 w-4 text-neon-green" /> Filtrer</span>
      <label className="text-zinc-500 text-[11px] uppercase">Du<br /><input data-testid={`${testPrefix}-from`} type="date" value={filters.from} max={filters.to || undefined} onChange={upd("from")} className={inp} /></label>
      <label className="text-zinc-500 text-[11px] uppercase">Au<br /><input data-testid={`${testPrefix}-to`} type="date" value={filters.to} min={filters.from || undefined} onChange={upd("to")} className={inp} /></label>
      <label className="text-zinc-500 text-[11px] uppercase">Vendeur / boutique<br />
        <select data-testid={`${testPrefix}-vendor`} value={filters.vendor} onChange={upd("vendor")} className={inp + " min-w-[180px]"}>
          <option value="">Tous les vendeurs</option>
          {vendors.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
        </select>
      </label>
      <span data-testid={`${testPrefix}-count`} className="text-zinc-400 text-xs pb-2 ml-auto">{shown} / {total} affichée{total > 1 ? "s" : ""}</span>
      {active && <button type="button" data-testid={`${testPrefix}-reset`} onClick={() => setFilters(EMPTY_FILTERS)} className="min-h-[40px] inline-flex items-center gap-1 text-xs uppercase font-bold border border-zinc-700 text-zinc-300 px-3 hover:border-neon-magenta hover:text-neon-magenta"><X className="h-3 w-3" /> Réinitialiser</button>}
    </div>
  );
}
